import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
    Button,
    ComposedModal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    ComboBox,
    DropdownSkeleton,
} from 'carbon-components-react';
import { api } from '../../helpers/api/api';
import { showNotification } from '../../helpers/notification/BaseNotification';
import { getError, entitiesLabels, apioperation } from '../../helpers/Constants';

export class FindSaipemCompilers extends Component {
    constructor(props) {
        super(props);
        const hocCardTranslateCompiler = this.props.isTranslate ? window.sessionStorage.getItem("hocCardTranslate") : null; //RITM0954296
        this.state = {
            loading: false,
            items: [],
            hocCardTranslateSaipemFields: JSON.parse(hocCardTranslateCompiler), //RITM0954296
        };
        // bind event handlers
        this.getCompilers = this.getCompilers.bind(this);
        this.handleClickOk = this.handleClickOk.bind(this);
        this.onChange = this.onChange.bind(this);
    }

    async componentDidMount() {
        this.setState({ loading: true });
        const items = await this.getCompilers();
        this.setState({ items, loading: false });
    }

    getCompilers = async () => {
        this.setState({ loading: true });

        let items = [];
        try {
            items = (await api.getAll(this.props.url)).data;
        } catch (error) {
            showNotification.error(this.state.hocCardTranslateSaipemFields?.msgError || `${entitiesLabels.ERROR}`, getError(error, entitiesLabels.USER, apioperation.GET));
        }
        return items;
    };

    handleClickOk = () => {
        const { item } = this.state;
        if (item == null) {
            if (this.state.hocCardTranslateSaipemFields?.msgWarning == null)
            { showNotification.warning(`${entitiesLabels.WARNING}`, 'Select user'); }
            else
                showNotification.warning(this.state.hocCardTranslateSaipemFields?.msgWarning, this.state.hocCardTranslateSaipemFields?.msgSaipemSelectUser);
            return;
        }
        this.props.onOk(item);
    };

    onChange = (selectedItem) => {
        const item = selectedItem ? selectedItem.selectedItem : null;
        this.setState({ item });
    };

    /** ****************************** */

    render() {
        const modalHeader = {
            //title: 'Select Car Owner from Saipem',
            title: '',
            iconDescription: 'Close',
            buttonOnClick: () => this.props.onCancel(0),
        };
        return (
            <ComposedModal
                className="light-modal"
                open={this.props.isOpenModal}
                danger="false"
                onClose={() => false}
            >
                <ModalHeader className="margin-modal" {...modalHeader} >{this.state.hocCardTranslateSaipemFields?.insertCAROwnerTitle || 'Select Car Owner from Saipem'} </ModalHeader>
                <ModalBody className="margin-modal modal-nooverflow confirm-modal">
                    {this.state.loading ? (
                        <DropdownSkeleton />
                    ) : (
                        <ComboBox
                            id="comboBoxCompiler"
                            disabled={this.state.items < 1}
                            className="selection-items-list-costum"
                            placeholder={this.state.hocCardTranslateSaipemFields?.hocprioritiesTitlePlaceholder || 'Choose a user'}
                            items={this.state.items}
                            onChange={this.onChange}
                            shouldFilterItem={({ item, inputValue }) =>
                                item.fullName?.toLowerCase().includes(inputValue.toLowerCase()) ||
                                item.email?.toLowerCase().includes(inputValue.toLowerCase())
                            }
                            itemToString={(item) =>
                                item ? item && item.email && `${item.name}  ${item.surname} (${item.email})` : ''
                            }
                            selectedItem={this.props.selectedItem}
                            initialSelectedItem={this.props.initialSelectedItem}
                        />
                    )}
                </ModalBody>
                <ModalFooter>
                    <Button kind="secondary" onClick={() => this.props.onCancel(0)}>
                        {this.state.hocCardTranslateSaipemFields?.carCancelTitle || 'Cancel'}
                    </Button>
                    <Button kind="primary" onClick={() => this.handleClickOk()}>
                        {this.state.hocCardTranslateSaipemFields?.carOkTitle || 'Ok'}
                    </Button>
                </ModalFooter>
            </ComposedModal>
        );
    }
}
FindSaipemCompilers.propTypes = {
    url: PropTypes.string.isRequired,
    onCancel: PropTypes.func.isRequired,
    onOk: PropTypes.func.isRequired,
    // eslint-disable-next-line react/forbid-prop-types
    selectedItem: PropTypes.object,
    initialSelectedItem: PropTypes.object,
    isOpenModal: PropTypes.bool,
    isTranslate: PropTypes.bool, //RITM0954296
};
FindSaipemCompilers.defaultProps = {
    selectedItem: null,
    isOpenModal: false,
    initialSelectedItem: null,
    isTranslate: false, //RITM0954296
};
export default FindSaipemCompilers;
